module.exports = __webpack_public_path__ + "img/gift_bg.8dd52c1.png";